var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKinarow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.2 0C7.64 0 8 0.36 8 0.8C8 2.24 8 5.76 8 7.2C8 7.64 7.64 8 7.2 8C5.76 8 2.24 8 0.8 8C0.36 8 0 7.64 0 7.2C0 5.76 0 2.24 0 0.8C0 0.36 0.36 0 0.8 0C2.24 0 5.76 0 7.2 0Z",
    id: "aa5LlAN7M"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.11 0C19.6 0 20 0.4 20 0.89C20 2.31 20 5.69 20 7.11C20 7.6 19.6 8 19.11 8C17.69 8 14.31 8 12.89 8C12.4 8 12 7.6 12 7.11C12 5.69 12 2.31 12 0.89C12 0.4 12.4 0 12.89 0C14.31 0 17.69 0 19.11 0Z",
    id: "ai2DndZYp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.11 0C31.6 0 32 0.4 32 0.89C32 2.31 32 5.69 32 7.11C32 7.6 31.6 8 31.11 8C29.69 8 26.31 8 24.89 8C24.4 8 24 7.6 24 7.11C24 5.69 24 2.31 24 0.89C24 0.4 24.4 0 24.89 0C26.31 0 29.69 0 31.11 0Z",
    id: "aLIxr6eI4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 12C19.64 12 20 12.36 20 12.8C20 14.24 20 17.76 20 19.2C20 19.64 19.64 20 19.2 20C17.76 20 14.24 20 12.8 20C12.36 20 12 19.64 12 19.2C12 17.76 12 14.24 12 12.8C12 12.36 12.36 12 12.8 12C14.24 12 17.76 12 19.2 12Z",
    id: "c2EmJjbCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2 24C31.64 24 32 24.36 32 24.8C32 26.24 32 29.76 32 31.2C32 31.64 31.64 32 31.2 32C29.76 32 26.24 32 24.8 32C24.36 32 24 31.64 24 31.2C24 29.76 24 26.24 24 24.8C24 24.36 24.36 24 24.8 24C26.24 24 29.76 24 31.2 24Z",
    id: "fYWpZX0Yz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11 12C7.6 12 8 12.4 8 12.89C8 14.31 8 17.69 8 19.11C8 19.6 7.6 20 7.11 20C5.69 20 2.31 20 0.89 20C0.4 20 0 19.6 0 19.11C0 17.69 0 14.31 0 12.89C0 12.4 0.4 12 0.89 12C2.31 12 5.69 12 7.11 12Z",
    id: "g360g6ucE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11 24C7.6 24 8 24.4 8 24.89C8 26.31 8 29.69 8 31.11C8 31.6 7.6 32 7.11 32C5.69 32 2.31 32 0.89 32C0.4 32 0 31.6 0 31.11C0 29.69 0 26.31 0 24.89C0 24.4 0.4 24 0.89 24C2.31 24 5.69 24 7.11 24Z",
    id: "b5x25dI9RC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.11 24C19.6 24 20 24.4 20 24.89C20 26.31 20 29.69 20 31.11C20 31.6 19.6 32 19.11 32C17.69 32 14.31 32 12.89 32C12.4 32 12 31.6 12 31.11C12 29.69 12 26.31 12 24.89C12 24.4 12.4 24 12.89 24C14.31 24 17.69 24 19.11 24Z",
    id: "bqee8ra6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.11 12C31.6 12 32 12.4 32 12.89C32 14.31 32 17.69 32 19.11C32 19.6 31.6 20 31.11 20C29.69 20 26.31 20 24.89 20C24.4 20 24 19.6 24 19.11C24 17.69 24 14.31 24 12.89C24 12.4 24.4 12 24.89 12C26.31 12 29.69 12 31.11 12Z",
    id: "cOI2zbpor"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aa5LlAN7M",
    opacity: 1,
    fill: "#3b82f6",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ai2DndZYp",
    opacity: 1,
    fill: "#6ee7b7",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aLIxr6eI4",
    opacity: 1,
    fill: "#3b82f6",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2EmJjbCF",
    opacity: 1,
    fill: "#3b82f6",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fYWpZX0Yz",
    opacity: 1,
    fill: "#3b82f6",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g360g6ucE9",
    opacity: 1,
    fill: "#3b82f6",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5x25dI9RC",
    opacity: 1,
    fill: "#3b82f6",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bqee8ra6c",
    opacity: 1,
    fill: "#6ee7b7",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cOI2zbpor",
    opacity: 1,
    fill: "#6ee7b7",
    fillOpacity: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKinarow);
export default __webpack_public_path__ + "static/media/kinarow.89e3490187c328d74fe1311a425f3615.svg";
export { ForwardRef as ReactComponent };